<template>
  <div class="container wc-container wc-container-720">
    <Form>
      <div class="page-settings">
        <div class="settings-item">
          <h4 class="settings-item--label">Livecast Page</h4>
          <i-switch v-model="settings.pageEnabled" @on-change="onUpdatePageSettings" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Page Logo</h4>
          <img :src="settings.logoUrl" v-if="settings.logoUrl" class="logo" alt="logo" />
          <div class="upload-wrapper">
            <Upload
              type="drag"
              :action="uploadServer"
              :on-success="handleLogoUpload"
              :format="['jpg','jpeg','png']"
              :max-size="3000"
            >
              <div class="upload-area">
                <p class="settings-text">Height must be 36px. jpg or png</p>
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>Upload a logo</p>
              </div>
            </Upload>
          </div>
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Background Image</h4>
          <img :src="settings.bgImgUrl" v-if="settings.bgImgUrl" class="logo" alt="logo" />
          <div class="upload-wrapper">
            <Upload
              type="drag"
              :action="uploadServer"
              :on-success="handleBgUpload"
              :format="['jpg','jpeg','png']"
              :max-size="3000"
            >
              <div class="upload-area">
                <p class="settings-text">Height must be 1920 x 1080px. jpg or png</p>
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>Upload Background Image</p>
              </div>
            </Upload>
          </div>
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Backgroung Image Position</h4>
          <Select v-model="settings.bgImgPosition" style="width:200px">
            <Option value="center">Center</Option>
            <Option value="left">Left</Option>
          </Select>
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Brand Color</h4>
          <Input v-model="settings.brandColor" type="text" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Call To Action Button</h4>
          <i-switch v-model="settings.callToActionEnabled" />

          <div class="additional-field" v-if="settings.callToActionEnabled">
            <FormItem label="Call To Action Text">
              <Input v-model="settings.callToActionText" type="text" />
            </FormItem>
            <FormItem label="Call To Action Link">
              <Input v-model="settings.callToActionLink" type="text" />
            </FormItem>
          </div>
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Custom Pages</h4>
          <i-switch v-model="settings.customPagesEnabled" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Custom Embed</h4>
          <i-switch v-model="settings.customEmbedEnabled" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Registration</h4>
          <i-switch v-model="settings.registrationEnabled" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Login Form</h4>
          <i-switch v-model="settings.loginFormEnabled" />
          <p class="settings-text">Put a login form on the landing page</p>
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Lobby Page</h4>
          <i-switch v-model="settings.lobbyPageEnabled" />
        </div>

        <div class="settings-item">
          <h4 class="settings-item--label">Redirect After Registration</h4>
          <i-switch v-model="settings.redirectAfterRegistrationEnabled" />

          <div class="additional-field" v-if="settings.redirectAfterRegistrationEnabled">
            <FormItem label="Redirect Url">
              <Input v-model="settings.redirectAfterRegistrationUrl" type="text" />
            </FormItem>
          </div>
        </div>

        <div class="settings-item">
          <Button
            type="primary"
            @click="onUpdatePageSettings()"
            style="float:right;"
            v-if="!isSaving"
          >Save</Button>
          <Button type="primary" style="float:right;" disable v-if="isSaving">Please wait</Button>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import $config from "@/config";

export default {
  data() {
    return {
      isSaving: false,
      settings: {
        webcastId: null,
        logoUrl: "",
        pageEnabled: false,
        callToActionEnabled: false,
        callToActionText: false,
        callToActionLink: false,
        customPagesEnabled: false,
        customEmbedEnabled: false,
        registrationEnabled: false,
        eventPasswordEnabled: false,
        loginFormEnabled: false,
        lobbyPageEnabled: false,
        redirectAfterRegistrationEnabled: false,
        redirectAfterRegistrationUrl: null,
        eventPassword: "",
        bgImgUrl: "",
        bgImgPosition: ""
      }
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("page-settings", {
      pageSettings: "getCopy"
    }),
    uploadServer() {
      return `${$config.uploadServer}`;
    }
  },

  methods: {
    ...mapActions("page-settings", {
      updatePageSettings: "patch",
      createPageSettings: "create",
      getPageSettings: "find"
    }),

    onUpdatePageSettings() {
      console.log(this.settings);
      this.$data.isSaving = true;
      if (!this.settings.eventPasswordEnabled) {
        this.settings.eventPassword = "";
      }

      this.updatePageSettings([this.pageSettings._id, this.settings, {}])
        .then(res => {
          this.$Message.success("Page settings has been updated");
          this.$data.isSaving = false;
        })
        .catch(err => {
          this.$Message.error("Error on page settings update");
          this.$data.isSaving = false;
        });
    },

    setExistingSettings(data) {
      this.settings = _.cloneDeep(data);
      console.log(this.settings);
    },

    handleLogoUpload(res, file) {
      this.$set(this.settings, "logoUrl", res);
    },
    handleBgUpload(res, file) {
      this.$set(this.settings, "bgImgUrl", res);
    }
  },
  created() {
    this.setExistingSettings(this.pageSettings);
  }
};
</script>

<style lang="scss" scoped>
.settings {
  &-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 30px 0;
    &:not(:last-of-type) {
      border-bottom: 0.5px solid #e9eaec;
    }
  }

  &-text {
    width: 100%;
    color: #abacaf;
  }
}

.logo {
  display: block;
  width: 120px;
  height: 36px;
  margin-bottom: 20px;
  object-fit: cover;
}

.upload {
  &-wrapper {
    width: 100%;
  }

  &-area {
    padding: 20px 0;
  }
}

.additional-field {
  width: 100%;
  margin-top: 30px;
}
</style>